// config.js
export const BASE_URL = 'https://api.sarpharma-international.com/sar-pharma';
export const HOST_URL = 'https://api.sarpharma-international.com';

// urls.js
export const PRODUCT_URL = '/v1/products';
export const CATEGORY_URL = '/v1/categories';
export const EMAIL_URL = '/v1/send/email';
export const LATEST_PRODUCT_URL = '/v1/products/latest';

// Add more URLs as needed
